import { useMutation, useQuery } from 'react-query';
import axios from 'axios';

export const cartMutation = () => {
  return useMutation(({ items }) => {
    return axios.post('/cart/add.js', {
      items,
    });
  });
};

export const useCartUpdate = () => {
  return useMutation(({ updates }) => {
    return axios.post('/cart/update.js', {
      updates,
      // items,
    });
  });
};

export const useUpdateNotes = () => {
  return useMutation((note) => {
    return axios.post('/cart/update.js', {
      note
    });
  });
};

export const useCartContents = () => {
  return useQuery('cart', async () => {
    var cartData;
    const { data } = await axios.get('/cart.js');
    // Bold:PRE
    if (typeof window.BOLD !== 'undefined'
      && typeof window.BOLD.common !== 'undefined'
      && typeof window.BOLD.common.cartDoctor !== 'undefined') {
      cartData = window.BOLD.common.cartDoctor.fix(data);
    } else {
      cartData = data
    }
    // Bold:PRE
    return cartData;
  });
};
